"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserWithoutStoreSchema = exports.UserSchema = exports.cognitoGroupsScopes = exports.CognitoGroups = exports.userGroupScopes = exports.ownerGroupScopes = exports.developerGroupScopes = exports.operatorGroupScopes = exports.adminGroupScopes = exports.Scopes = exports.UserSettingsSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
exports.UserSettingsSchema = zod_1.z.object({
    ftuComponentsRead: zod_1.z.array(__1.ShortStringSchema).optional(),
    isOnboardingCompleted: zod_1.z.boolean().optional(),
});
var Scopes;
(function (Scopes) {
    Scopes["UsersReadAll"] = "users:read:all";
    Scopes["UsersWriteAll"] = "users:write:all";
    Scopes["UsersDeleteAll"] = "users:delete:all";
    Scopes["UsersAdminAll"] = "users:admin:all";
    Scopes["UsersRead"] = "users:read";
    Scopes["UsersWrite"] = "users:write";
    Scopes["UsersDelete"] = "users:delete";
    Scopes["ChannelsReadAll"] = "channels:read:all";
    Scopes["ChannelsWriteAll"] = "channels:write:all";
    Scopes["ChannelsDeleteAll"] = "channels:delete:all";
    Scopes["ChannelsAdminAll"] = "channels:admin:all";
    Scopes["ChannelsRead"] = "channels:read";
    Scopes["StoresReadAll"] = "stores:read:all";
    Scopes["StoresWriteAll"] = "stores:write:all";
    Scopes["StoresDeleteAll"] = "stores:delete:all";
    Scopes["StoresAdminAll"] = "stores:admin:all";
    Scopes["StoresRead"] = "stores:read";
    Scopes["StoresWrite"] = "stores:write";
    Scopes["StoresDelete"] = "stores:delete";
    Scopes["StoreCategoriesReadAll"] = "store-categories:read:all";
    Scopes["StoreCategoriesWriteAll"] = "store-categories:write:all";
    Scopes["StoreCategoriesDeleteAll"] = "store-categories:delete:all";
    Scopes["StoreCategoriesAdminAll"] = "store-categories:admin:all";
    Scopes["StoreCategoriesRead"] = "store-categories:read";
    Scopes["StoreCategoriesWrite"] = "store-categories:write";
    Scopes["StoreCategoriesDelete"] = "store-categories:delete";
    Scopes["ItemsReadAll"] = "items:read:all";
    Scopes["ItemsWriteAll"] = "items:write:all";
    Scopes["ItemsDeleteAll"] = "items:delete:all";
    Scopes["ItemsAdminAll"] = "items:admin:all";
    Scopes["ItemsRead"] = "items:read";
    Scopes["ItemsWrite"] = "items:write";
    Scopes["ItemsDelete"] = "items:delete";
    Scopes["PromotionsReadAll"] = "promotions:read:all";
    Scopes["PromotionsWriteAll"] = "promotions:write:all";
    Scopes["PromotionsDeleteAll"] = "promotions:delete:all";
    Scopes["PromotionsAdminAll"] = "promotions:admin:all";
    Scopes["PromotionsRead"] = "promotions:read";
    Scopes["PromotionsWrite"] = "promotions:write";
    Scopes["PromotionsDelete"] = "promotions:delete";
    Scopes["PromotionTemplatesReadAll"] = "promotion-templates:read:all";
    Scopes["PromotionTemplatesWriteAll"] = "promotion-templates:write:all";
    Scopes["PromotionTemplatesDeleteAll"] = "promotion-templates:delete:all";
    Scopes["PromotionTemplatesAdminAll"] = "promotion-templates:admin:all";
    Scopes["PromotionTemplatesRead"] = "promotion-templates:read";
    Scopes["PromotionTemplatesWrite"] = "promotion-templates:write";
    Scopes["PromotionTemplatesDelete"] = "promotion-templates:delete";
    Scopes["ChannelConnectionsReadAll"] = "channel-connections:read:all";
    Scopes["ChannelConnectionsWriteAll"] = "channel-connections:write:all";
    Scopes["ChannelConnectionsDeleteAll"] = "channel-connections:delete:all";
    Scopes["ChannelConnectionsAdminAll"] = "channel-connections:admin:all";
    Scopes["ChannelConnectionsRead"] = "channel-connections:read";
    Scopes["ChannelConnectionsWrite"] = "channel-connections:write";
    Scopes["ChannelConnectionsDelete"] = "channel-connections:delete";
    Scopes["OrdersReadAll"] = "orders:read:all";
    Scopes["OrdersWriteAll"] = "orders:write:all";
    Scopes["OrdersDeleteAll"] = "orders:delete:all";
    Scopes["OrdersAdminAll"] = "orders:admin:all";
    Scopes["OrdersRead"] = "orders:read";
    Scopes["OrdersWrite"] = "orders:write";
    Scopes["CatalogReadAll"] = "catalog:read:all";
    Scopes["CatalogWriteAll"] = "catalog:write:all";
    Scopes["CatalogDeleteAll"] = "catalog:delete:all";
    Scopes["CatalogAdminAll"] = "catalog:admin:all";
    Scopes["CatalogRead"] = "catalog:read";
    Scopes["CatalogWrite"] = "catalog:write";
    Scopes["CategoriesReadAll"] = "categories:read:all";
    Scopes["CategoriesWriteAll"] = "categories:write:all";
    Scopes["CategoriesDeleteAll"] = "categories:delete:all";
    Scopes["CategoriesAdminAll"] = "categories:admin:all";
    Scopes["CategoriesRead"] = "categories:read";
    Scopes["CategoriesWrite"] = "categories:write";
    Scopes["ItemIssuesReadAll"] = "item-issues:read:all";
    Scopes["ItemIssuesWriteAll"] = "item-issues:write:all";
    Scopes["ItemIssuesDeleteAll"] = "item-issues:delete:all";
    Scopes["ItemIssuesAdminAll"] = "item-issues:admin:all";
    Scopes["ItemIssuesRead"] = "item-issues:read";
    Scopes["ItemIssuesWrite"] = "item-issues:write";
    Scopes["SynchronizationsReadAll"] = "synchronizations:read:all";
    Scopes["SynchronizationsWriteAll"] = "synchronizations:write:all";
    Scopes["SynchronizationsDeleteAll"] = "synchronizations:delete:all";
    Scopes["SynchronizationsAdminAll"] = "synchronizations:admin:all";
    Scopes["SynchronizationsRead"] = "synchronizations:read";
    Scopes["SynchronizationsWrite"] = "synchronizations:write";
    Scopes["NotificationsReadAll"] = "notifications:read:all";
    Scopes["NotificationsWriteAll"] = "notifications:write:all";
    Scopes["NotificationsDeleteAll"] = "notifications:delete:all";
    Scopes["NotificationsAdminAll"] = "notifications:admin:all";
    Scopes["NotificationsRead"] = "notifications:read";
    Scopes["NotificationsWrite"] = "notifications:write";
    Scopes["ReportsReadAll"] = "reports:read:all";
    Scopes["ReportsWriteAll"] = "reports:write:all";
    Scopes["ReportsDeleteAll"] = "reports:delete:all";
    Scopes["ReportsAdminAll"] = "reports:admin:all";
    Scopes["ReportsRead"] = "reports:read";
    Scopes["ReportsWrite"] = "reports:write";
    Scopes["PlansReadAll"] = "plans:read:all";
    Scopes["PlansWriteAll"] = "plans:write:all";
    Scopes["PlansDeleteAll"] = "plans:delete:all";
    Scopes["PlansAdminAll"] = "plans:admin:all";
    Scopes["PlansRead"] = "plans:read";
    Scopes["ContractsReadAll"] = "contracts:read:all";
    Scopes["ContractsWriteAll"] = "contracts:write:all";
    Scopes["ContractsDeleteAll"] = "contracts:delete:all";
    Scopes["ContractsAdminAll"] = "contracts:admin:all";
    Scopes["ContractsRead"] = "contracts:read";
    Scopes["ContractsWrite"] = "contracts:write";
    Scopes["FeedbacksAdminAll"] = "feedbacks:admin:all";
    Scopes["FeedbacksRead"] = "feedbacks:read";
    Scopes["FeedbacksReadAll"] = "feedbacks:read:all";
    Scopes["FeedbacksWrite"] = "feedbacks:write";
    Scopes["FeedbacksWriteAll"] = "feedbacks:write:all";
    Scopes["ReferralsAdminAll"] = "referrals:admin:all";
    Scopes["ReferralsRead"] = "referrals:read";
    Scopes["ReferralsReadAll"] = "referrals:read:all";
    Scopes["ReferralsWrite"] = "referrals:write";
    Scopes["ReferralsWriteAll"] = "referrals:write:all";
    Scopes["PartnersAdminAll"] = "partners:admin:all";
    Scopes["PartnersRead"] = "partners:read";
    Scopes["PartnersReadAll"] = "partners:read:all";
    Scopes["PartnersWrite"] = "partners:write";
    Scopes["PartnersWriteAll"] = "partners:write:all";
    Scopes["LicensesAdminAll"] = "licenses:admin:all";
    Scopes["LicensesRead"] = "licenses:read";
    Scopes["LicensesReadAll"] = "licenses:read:all";
    Scopes["LicensesWrite"] = "licenses:write";
    Scopes["LicensesWriteAll"] = "licenses:write:all";
    Scopes["DistributorsAdminAll"] = "distributors:admin:all";
    Scopes["DistributorsRead"] = "distributors:read";
    Scopes["DistributorsReadAll"] = "distributors:read:all";
    Scopes["DistributorsWrite"] = "distributors:write";
    Scopes["DistributorsWriteAll"] = "distributors:write:all";
})(Scopes || (exports.Scopes = Scopes = {}));
exports.adminGroupScopes = [
    Scopes.ChannelsAdminAll,
    Scopes.StoresAdminAll,
    Scopes.ItemsAdminAll,
    Scopes.ChannelConnectionsAdminAll,
    Scopes.OrdersAdminAll,
    Scopes.CatalogAdminAll,
    Scopes.CategoriesAdminAll,
    Scopes.ItemIssuesAdminAll,
    Scopes.SynchronizationsAdminAll,
    Scopes.NotificationsAdminAll,
    Scopes.ReportsAdminAll,
    Scopes.UsersAdminAll,
    Scopes.PlansAdminAll,
    Scopes.ContractsAdminAll,
    Scopes.PromotionTemplatesAdminAll,
    Scopes.PromotionsAdminAll,
    Scopes.FeedbacksAdminAll,
    Scopes.ReferralsAdminAll,
    Scopes.PartnersAdminAll,
    Scopes.LicensesAdminAll,
    Scopes.DistributorsAdminAll,
];
exports.operatorGroupScopes = [
    Scopes.ChannelsReadAll,
    Scopes.ChannelsWriteAll,
    Scopes.StoresReadAll,
    Scopes.StoresWriteAll,
    Scopes.ItemsReadAll,
    Scopes.ItemsWriteAll,
    Scopes.ChannelConnectionsReadAll,
    Scopes.ChannelConnectionsWriteAll,
    Scopes.OrdersReadAll,
    Scopes.OrdersWriteAll,
    Scopes.CatalogReadAll,
    Scopes.CatalogWriteAll,
    Scopes.CategoriesReadAll,
    Scopes.CategoriesWriteAll,
    Scopes.ItemIssuesReadAll,
    Scopes.ItemIssuesWriteAll,
    Scopes.SynchronizationsReadAll,
    Scopes.SynchronizationsWriteAll,
    Scopes.NotificationsReadAll,
    Scopes.NotificationsWriteAll,
    Scopes.ReportsReadAll,
    Scopes.ReportsWriteAll,
    Scopes.UsersReadAll,
    Scopes.UsersWriteAll,
    Scopes.PlansReadAll,
    Scopes.ContractsReadAll,
    Scopes.PromotionTemplatesReadAll,
    Scopes.PromotionsReadAll,
    Scopes.FeedbacksReadAll,
    Scopes.ReferralsReadAll,
    Scopes.PartnersReadAll,
    Scopes.LicensesReadAll,
    Scopes.DistributorsReadAll,
];
exports.developerGroupScopes = [
    Scopes.ChannelsReadAll,
    Scopes.ChannelsWriteAll,
    Scopes.StoresReadAll,
    Scopes.StoresWriteAll,
    Scopes.ItemsReadAll,
    Scopes.ItemsWriteAll,
    Scopes.ChannelConnectionsReadAll,
    Scopes.ChannelConnectionsWriteAll,
    Scopes.OrdersReadAll,
    Scopes.OrdersWriteAll,
    Scopes.CatalogReadAll,
    Scopes.CatalogWriteAll,
    Scopes.CategoriesReadAll,
    Scopes.CategoriesWriteAll,
    Scopes.ItemIssuesReadAll,
    Scopes.ItemIssuesWriteAll,
    Scopes.SynchronizationsReadAll,
    Scopes.SynchronizationsWriteAll,
    Scopes.NotificationsReadAll,
    Scopes.NotificationsWriteAll,
    Scopes.ReportsReadAll,
    Scopes.ReportsWriteAll,
    Scopes.UsersReadAll,
    Scopes.UsersWriteAll,
    Scopes.PlansReadAll,
    Scopes.ContractsReadAll,
    Scopes.PromotionTemplatesReadAll,
    Scopes.PromotionTemplatesWriteAll,
    Scopes.PromotionsReadAll,
    Scopes.PromotionsWriteAll,
    Scopes.FeedbacksReadAll,
    Scopes.FeedbacksWriteAll,
    Scopes.ReferralsReadAll,
    Scopes.ReferralsWriteAll,
    Scopes.PartnersReadAll,
    Scopes.PartnersWriteAll,
    Scopes.LicensesReadAll,
    Scopes.LicensesWriteAll,
    Scopes.DistributorsReadAll,
    Scopes.DistributorsWriteAll,
];
exports.ownerGroupScopes = [
    Scopes.ChannelsRead,
    Scopes.StoresRead,
    Scopes.StoresWrite,
    Scopes.StoresDelete,
    Scopes.StoreCategoriesRead,
    Scopes.StoreCategoriesWrite,
    Scopes.StoreCategoriesDelete,
    Scopes.ItemsRead,
    Scopes.ItemsWrite,
    Scopes.ItemsDelete,
    Scopes.ChannelConnectionsRead,
    Scopes.ChannelConnectionsWrite,
    Scopes.ChannelConnectionsDelete,
    Scopes.OrdersRead,
    Scopes.OrdersWrite,
    Scopes.CatalogRead,
    Scopes.CategoriesRead,
    Scopes.ItemIssuesRead,
    Scopes.SynchronizationsRead,
    Scopes.SynchronizationsWrite,
    Scopes.NotificationsRead,
    Scopes.NotificationsWrite,
    Scopes.ReportsRead,
    Scopes.UsersRead,
    Scopes.UsersWrite,
    Scopes.UsersDelete,
    Scopes.PlansRead,
    Scopes.ContractsRead,
    Scopes.ContractsWrite,
    Scopes.PromotionTemplatesRead,
    Scopes.PromotionsRead,
    Scopes.PromotionsWrite,
    Scopes.FeedbacksRead,
    Scopes.FeedbacksWrite,
    Scopes.ReferralsRead,
    Scopes.ReferralsWrite,
    Scopes.PartnersRead,
    Scopes.LicensesRead,
    Scopes.DistributorsRead,
];
exports.userGroupScopes = [
    Scopes.ChannelsRead,
    Scopes.StoresRead,
    Scopes.StoreCategoriesRead,
    Scopes.ItemsRead,
    Scopes.ChannelConnectionsRead,
    Scopes.OrdersRead,
    Scopes.CatalogRead,
    Scopes.CategoriesRead,
    Scopes.ItemIssuesRead,
    Scopes.SynchronizationsRead,
    Scopes.NotificationsRead,
    Scopes.NotificationsWrite,
    Scopes.ReportsRead,
    Scopes.UsersRead,
    Scopes.UsersWrite,
    Scopes.UsersDelete,
    Scopes.PlansRead,
    Scopes.ContractsRead,
    Scopes.PromotionTemplatesRead,
    Scopes.PromotionsRead,
    Scopes.FeedbacksRead,
    Scopes.ReferralsRead,
    Scopes.PartnersRead,
    Scopes.LicensesRead,
    Scopes.DistributorsRead,
];
var CognitoGroups;
(function (CognitoGroups) {
    CognitoGroups["Admins"] = "Admins";
    CognitoGroups["Operators"] = "Operators";
    CognitoGroups["Developers"] = "Developers";
    CognitoGroups["StoreOwners"] = "StoreOwners";
    CognitoGroups["StoreUsers"] = "StoreUsers";
})(CognitoGroups || (exports.CognitoGroups = CognitoGroups = {}));
exports.cognitoGroupsScopes = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Admins: exports.adminGroupScopes,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Operators: exports.operatorGroupScopes,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Developers: exports.developerGroupScopes,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    StoreOwners: exports.ownerGroupScopes,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    StoreUsers: exports.userGroupScopes,
};
exports.UserSchema = __1.BaseSchema.extend({
    currentStore: zod_1.z.lazy(() => __1.BaseStoreSchema.partial().required({ id: true })).optional(),
    name: __1.ShortStringSchema,
    email: __1.ShortStringSchema.email(),
    isEmailVerified: zod_1.z.boolean().optional(),
    profileImageUri: __1.LongStringSchema.url().optional(),
    privacyPolicyAgreedVersion: __1.ShortStringSchema.optional(),
    privacyPolicyAgreedAt: zod_1.z.coerce.date().optional(),
    termsAndConditionsAgreedVersion: __1.ShortStringSchema.optional(),
    termsAndConditionsAgreedAt: zod_1.z.coerce.date().optional(),
    isPhoneNumberVerified: zod_1.z.boolean().optional(),
    lastSignInAt: zod_1.z.coerce.date().optional(),
    locale: __1.ShortStringSchema.optional(),
    timeZone: zod_1.z.string().optional(),
    signInCount: zod_1.z.number().nonnegative().optional(),
    phoneNumber: __1.ShortStringSchema.or(__1.PhoneSchema).optional(),
    settings: exports.UserSettingsSchema.optional(),
    userOrigin: __1.OriginSchema.optional(),
    hasSignedInMultipleTimes: zod_1.z.boolean().optional(),
    activityLevel: zod_1.z.nativeEnum(__1.UserActivityLevel).optional(),
    intercomHash: zod_1.z.string().optional(),
});
exports.UserWithoutStoreSchema = exports.UserSchema.omit({ currentStore: true });
//# sourceMappingURL=index.js.map